<template>
  <div class="monthly-offers-view view">
    <div class="container box">
      <h1 class="is-bold has-bottom-margin">Aktuella erbjudanden</h1>
      <p class="has-text-centered has-top-margin" v-if="false">
        Det finns inga erbjudanden just nu.
      </p>
      <div class="columns" v-else>
        <div class="column">
          <CampaignBlock></CampaignBlock>
        </div>
      </div>
      <br />
      <RouterLink
        :to="{ name: 'home' }"
        class="button is-info is-horizontal-middle"
        >Tillbaka</RouterLink
      >
    </div>
  </div>
</template>

<script>
import CampaignBlock from "@/components/blocks/CampaignBlock.vue";

export default {
  name: "monthly-offers-view",
  components: { CampaignBlock },
  data() {
    return {
      isLoading: true,
    };
  },
  async created() {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
